import {
  SHBox,
  SHStack,
  SHTableCell,
  SHTableRow,
  SHTableRowProps,
  SHTypography,
} from "@components/design-systems";
import { ArrowDownSVG } from "@components/svgs";
import { BusinessMetricTypeId } from "@models/configuration";
import {
  ReviewFeatureDTO,
  ReviewSectionDTO,
  ReviewSelectedProductDTO,
} from "@models/reviews/entities/steps/feature";
import { Collapse, useTheme } from "@mui/material";
import { renderBusinessMetricIcon } from "@pages/platform-analysis/_id/steps/business-metric/analysis/components/group-row";
import { useState } from "react";
import { ReviewBusinessFeatureTableRow } from "../feature-row";
import {
  FeatureReviewTableCell,
  FeatureReviewTableCellProps,
} from "@pages/reviews/_id/steps/feature/analysis/components/table-cell";
import { useReview } from "@hooks/useReview";

interface BusinessAnalysisGroupTableRowProps {
  groupData?: ReviewSectionDTO;
  selectedProducts?: ReviewSelectedProductDTO[];
}

export const ReviewBusinessMetricGroupTableRow = ({
  groupData,
  selectedProducts,
  ...others
}: BusinessAnalysisGroupTableRowProps &
  FeatureReviewTableCellProps &
  SHTableRowProps) => {
  const { palette } = useTheme();
  const { setTotalCollapsedBusinessMetricRows } = useReview();

  const [expandFeatures, setExpandFeatures] = useState(true);

  const totalPlatforms = selectedProducts?.length;

  return (
    <>
      <SHTableRow
        sx={{
          background: `${palette.common.white} !important`,
        }}
        {...others}
      >
        <FeatureReviewTableCell isFirstColumn>
          <SHStack
            direction={"row"}
            alignItems={"center"}
            justifyContent="space-between"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setExpandFeatures(!expandFeatures);

              const totalSelectedFeature = groupData?.totalSelectedFeature ?? 0;
              setTotalCollapsedBusinessMetricRows(
                expandFeatures ? totalSelectedFeature : -totalSelectedFeature,
              );
            }}
          >
            <SHStack
              direction={"row"}
              alignItems={"center"}
              gap={"5px"}
              height={42}
            >
              {renderBusinessMetricIcon(groupData?.businessMetricTypeId)}
              <SHTypography
                variant="subtitle2"
                paddingTop={"5px"}
                fontSize={13}
              >
                {groupData?.businessMetricTypeId === BusinessMetricTypeId.Esg
                  ? "ESG policies"
                  : groupData?.businessMetricTypeName}
              </SHTypography>
            </SHStack>
            <SHBox
              alignItems={"center"}
              sx={{
                display: "flex",
                transition: "all ease-in-out 0.2s",
                transform: `rotate(${expandFeatures ? 0 : 180}deg)`,
              }}
            >
              <ArrowDownSVG width={16} height={16} />
            </SHBox>
          </SHStack>
        </FeatureReviewTableCell>
        {Array.from(Array(totalPlatforms).keys()).map((index) => (
          <FeatureReviewTableCell key={index}></FeatureReviewTableCell>
        ))}
      </SHTableRow>

      <SHTableRow>
        <SHTableCell
          colSpan={groupData?.analysisData?.length! + 1}
          sx={{ padding: 0, left: 0, borderLeft: "none !important" }}
        >
          <Collapse in={expandFeatures} timeout="auto">
            {groupData?.features?.map((feature: ReviewFeatureDTO) => (
              <ReviewBusinessFeatureTableRow
                key={feature?.id}
                featureData={feature}
                selectedProducts={selectedProducts}
              />
            ))}
          </Collapse>
        </SHTableCell>
      </SHTableRow>
    </>
  );
};
